// Imports in this file have to relative because import aliases are not supported in Nuxt server

import BaseService from './BaseService';
import getHealthCheckStatus from '../../libs/health-check/utils/getHealthCheckStatus';
import RedisCache from '../../libs/redis/RedisCache';
export default class Service extends BaseService {
  constructor(variables?: { req?: PortalRootIncomingMessage }) {
    super(variables);

    this.useCacheProvider(new RedisCache());

    this.setHealthCheckStatus(getHealthCheckStatus());
  }
}
